
import type { RouteObject } from "react-router-dom";
import Home from "../pages/home/page";
import SMSSignupPage from "../pages/sms-signup/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sms-signup",
    element: <SMSSignupPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
